"use strict";
ui.loadTemplateFile("questlist.html");

class QuestListDialog extends Dialog {
    _element: any;
    _titleBar: any;
    _questList: any;
    _description: any;
    _items: any[];
    _selectedIndex: any;
    _data: any;

    constructor(questData: any) {
        super("questlist.html");

        this._questList = ui.list(this, ".list.quests");
        this._description = ui.label(this, ".label.description");

        this._items = [];
        for (let i = 1; i <= 6; ++i) {
            this._items.push(ui.iconslot(this, ".quest-slot-" + i));
        }

        this._selectedIndex = 0;

        ui.button(this, ".button.abandon").on(
            "clicked",
            this._abandonQuest.bind(this)
        );

        this._data = questData;
        this._data.on("changed", this._update.bind(this));
        this._update();
    }

    _selectQuest(index: any) {
        let self = this;
        this._selectedIndex = index;
        let quest = this._data.quests?.[index];

        this._description.clear();

        for (let i = 0; i < this._items.length; ++i) {
            this._items[i].clear();
        }

        if (!quest) {
            return;
        }

        GDM.get(
            "list_quest",
            "quest_names",
            "item_data",
            function (questData: any, questString: any, itemData: any) {
                let row = questData.row(quest.id);
                let str = questString.getByKey(row[6]);
                let html = "<b>" + str.text + "</b>";
                html += "<p>" + str.comment + "</p>";
                html += "<p>" + str.quest1 + "</p>";
                html += "<p>" + str.quest2 + "</p>";
                self._description.html(html);

                for (let i = 0, j = 0; i < self._data.items.length; ++i) {
                    const questItem = self._data.items[i];

                    if (questItem.quest === quest.id) {
                        let slot = self._items[j++];
                        slot.setItem(questItem.item);
                    }
                }

                // TODO: Update quest timer
            }
        );
    }

    _abandonQuest() {
        const quest = this._data.quests?.[this._selectedIndex];
        if (!quest || !quest.id) {
            return;
        }
        netGame.abandonQuest(this._selectedIndex, quest.id);
    }

    _update() {
        const self = this;

        GDM.get("list_quest", "quest_names", function (questData: any, questString: any) {
            self._questList.clear();

            for (let i = 0; i < self._data.quests?.length; ++i) {
                // TODO: quests is undefined
                const quest = self._data.quests[i];

                if (quest.id > 0) {
                    const row = questData.row(quest.id);
                    const str = questString.getByKey(row[6]);
                    const item = ui.listitem();
                    item.text(str.text);
                    self._questList
                        .append(item)
                        .on("clicked", self._selectQuest.bind(self, i));
                }
            }

            self._questList.index(0);
        });
    }
}

ui.QuestListDialog = QuestListDialog;

ui.questListDialog = function (questData: any) {
    return new ui.QuestListDialog(questData);
};
